exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".panel-body[data-v-7d8f12a0]{padding:10px}", "", {"version":3,"sources":["/workspace/src/views/order-review/pages/OrderReviewLayoutPanel.vue"],"names":[],"mappings":"AACA,6BAA6B,YAAY,CACxC","file":"OrderReviewLayoutPanel.vue","sourcesContent":["\n.panel-body[data-v-7d8f12a0]{padding:10px\n}\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":true,"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-7d8f12a0","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/dist/cjs.js?{"sourceMap":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=1!./src/views/order-review/pages/OrderReviewLayoutPanel.vue
// module id = 4729
// module chunks = 5